import * as React from "react";
import { FunctionComponent } from "react";
import "./SuccessfulAction.css";
import { DefaultButton } from "@fluentui/react";
import BackHeader from "../back-header/BackHeader";

export interface Props {
  headerTitle: string;
  title: string;
  description: string;
  actionButtonText: string;
  onCloseClick?: () => void;
  onActionButtonClick?: () => void;
}

const SuccessfulAction: FunctionComponent<Props> = (props: Props) => {
  const { headerTitle, title, description, actionButtonText, onCloseClick, onActionButtonClick } = props;

  return (
    <>
      <div>
        <BackHeader title={headerTitle} onBackClick={onActionButtonClick}></BackHeader>

        <hr className="successful-action-dividing"></hr>
        <div className="successful-action-title">{title}</div>
        <div className="successful-action-description">{description}</div>
        <div className="successful-action-bottom-panel">
          <hr className="successful-action-dividing-bottom"></hr>
          <span>
            <DefaultButton
              className="successful-action-btn"
              toggle
              text={actionButtonText}
              onClick={() => {
                if (onActionButtonClick) onActionButtonClick();
              }}
            />
          </span>
          <span>
            <DefaultButton
              className="successful-close-btn"
              toggle
              text="Close"
              onClick={() => {
                if (onCloseClick) onCloseClick();
              }}
            />
          </span>
        </div>
      </div>
    </>
  );
};

export default SuccessfulAction;
